<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardInfo">
                <vs-row> 
                    <vs-col sm="12" lg="6">      
                        <h4 class="p-2">Configuración de boleta</h4>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <vs-button
                            @click="activeAgregar =!activeAgregar"
                            success
                            class="ml-auto"
                        >
                            <i class="fas fa-plus mr-2"></i> Agregar nueva configuración
                        </vs-button>
                        <crear v-model="activeAgregar"  :instituciones="instituciones" :institucionSelect="institucion" :cicloEscolarSelect="cicloEscolar" :programaSelect="programa" @refreshTable="getRefresh"></crear>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="cicloEscolar" class="labelInput">
                                Ciclo Escolar
                            </label>
                            <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="programa" class="labelInput">
                                Programa
                            </label>
                            <vs-select filter :loading="loadingPrograma" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length || nivel != ''" autocomplete="off">
                                <template #message-danger v-if="errorFields.includes('programa')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                            <div v-if="programa !== ''" @click="programa = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="nivel" class="labelInput">
                                Nivel Académico
                            </label>
                            <vs-select filter :loading="loadingNivel" class="aqui pt-0" id="nivel" placeholder="Seleccionar Nivel Académico" :key="nivelId" v-model="nivel" :disabled="!niveles.length || programa != ''">
                                <template #message-danger v-if="errorFields.includes('nivel')">
                                    Requerido
                                </template>
                                    <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                            </vs-select>
                            <div v-if="nivel !== ''" @click="nivel = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="12" style="margin-top: 23px; display: flex">
                        <vs-button 
                            class="ml-auto mb-3"
                            v-on:click="getInfoConfiguracionBoleta()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                    
                </vs-row>
                <vs-alert v-if="alerta === true">
                    <template #title>
                        No se encontró información
                    </template>
                    Te sugerimos agregar una nueva configuración
                </vs-alert>
                <configuracion :users="users"  @refreshTable="getInfoConfiguracionBoleta"></configuracion>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import servicios from '../../../../api/requests/servicios'
import catalogos from '../../../../api/requests/catalogos.js'
import academico from '../../../../api/requests/academico.js'
import configuracion from './tabla-configuracion-boleta.vue'
import crear from './modal/crear.vue'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            errorInstituto: false,
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            programa: '',
            programas: [],
            programaId: (new Date()).getTime(),
            loadingPrograma: false,
            nivel: '',
            niveles: [],
            nivelId: (new Date()).getTime(),
            loadingNivel: false,
            errorFields: [],
            activeAgregar: false,
            users: [],
            alerta: false,
            loadingInstituto: false,
            loadingCiclo: false,
            programaRefresh: '',
            tache: false
        }
    },
    components:{
        configuracion,
        crear
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await servicios.getInstitucion()
                this.instituciones = response.data
                this.loadingInstituto = false
                this.institucionId = (new Date()).getTime()
            }
            catch{
                
            }
        },
        async getCicloEscolar() {
            this.loadingCiclo = true
            const { data: response } = await servicios.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingCiclo = false
        },
        async getPrograma(){
            if (this.cicloEscolar) {
                this.programa = ''
                this.loadingPrograma = true
                try {
                    const {data: response} = await catalogos.getProgramas(this.institucion)
                    this.programas = response
                    this.programaId = (new Date()).getTime()
                    this.loadingPrograma = false
                } catch (error) {
                    
                }
            }
        },
        async getNivelAcademico() {
            if(this.institucion){
                this.nivel = ''
                this.loadingSelect = true
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await academico.getNivelAcademico(params)
                this.niveles = response
                this.nivelId = (new Date()).getTime()
                this.loadingSelect = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if(this.nivel == ''){
                if (!this.programa) {
                    this.errorFields.push('programa')
                }
            }
            if(this.programa == ''){
                if (!this.nivel) {
                    this.errorFields.push('nivel')
                }
            }
            if (!this.errorFields.length){
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                }
                if(this.programa){
                    params.programa_id = this.programa
                }else if(this.nivel){
                    params.nivel_academico_id = this.nivel
                }
                return params
            } else {
                return null
            }
        },
        async getInfoConfiguracionBoleta(){
            const datos = this.sanityForm()
            if(datos){
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await academico.getInfoConfiguracionBoleta(datos)
                    if(response[0]){
                        this.alerta = false
                        this.users = response
                    }else{
                        this.users = []
                        this.alerta = true
                    }
                    loading.close()
                } catch{
                    loading.close()
                }
            }
        },
        async getRefresh(institucion, cicloEscolar, programa){
                const loading = this.$vs.loading()
                this.institucion = institucion
                this.cicloEscolar = cicloEscolar
                console.log(programa)
                this.programaRefresh = programa
                const datos = {
                    institucion_id: institucion,
                    ciclo_escolar_id: cicloEscolar,
                    programa_id: programa
                }
                try{
                    
                    this.programa = programa
                    const { data: response } = await academico.getInfoConfiguracionBoleta(datos)
                    this.users = response
                    loading.close()
                } catch{
                    loading.close()
                }
        },
    },
    watch:{
        institucion(){
            this.getCicloEscolar()
            this.getPrograma()
            this.getNivelAcademico()
        },
        cicloEscolar(){
            this.getPrograma()
            this.programa = this.programaRefresh 
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardInfo{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>